const BACKEND_HOST = process.env.BACKEND_HOST
const BACKEND_PORT = process.env.BACKEND_PORT
const HOST = `${BACKEND_HOST}:${BACKEND_PORT}`

export const CONFIRM_EMPLOYEE = `${HOST}/confirm_employee`



// WEBPACK FOOTER //
// ./app/api/confirm-employee/constants.js